import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ExpandMore } from '@mui/icons-material';
import { useFormikContext } from 'formik';
import { AccordionPracticeVM, PracticeDetailVM } from 'practice/view-models/practice-detail';
import Form from './form';

interface AccordionPracticeProps {
  disabled?: boolean;
  isDetail?: boolean;
}

const AccordionPracticeComponent = ({
  disabled = false,
  isDetail,
}: AccordionPracticeProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const formContext = useFormikContext<PracticeDetailVM>();
  const onChange = useEventCallback(
    (key: keyof AccordionPracticeVM, value: AccordionPracticeVM[keyof AccordionPracticeVM]) => {
      formContext.setFieldValue('practice', {
        ...(formContext.values.practice || {}),
        [key]: value,
      });
    }
  );

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="accordion-practice-content"
        id="accordion-practice-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Pratica</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Form
          onChange={onChange}
          disabled={disabled}
          values={formContext.values.practice}
          isDetail={isDetail}
        />
      </AccordionDetails>
    </Accordion>
  );
};

AccordionPracticeComponent.displayName = 'Practice Detail - Form - accordion practice';

const AccordionPractice = memo(AccordionPracticeComponent);

export default AccordionPractice;
